import type { BrandPaletteEntry, BrandThemeHistoryEntry } from '../types/gotypes'

type Palette = Record<string, BrandPaletteEntry> | undefined

const sameEntry = (a: BrandPaletteEntry | undefined, b: BrandPaletteEntry | undefined) =>
  Boolean(a) && Boolean(b) && a!.color === b!.color && (a!.aliases || []).join(' ') === (b!.aliases || []).join(' ')

/** Brands whose colour or aliases changed, or that were added or removed (sorted). */
export function changedBrands(before: Palette, after: Palette): string[] {
  const names = new Set([...Object.keys(before || {}), ...Object.keys(after || {})])
  return Array.from(names).filter((n) => !sameEntry(before?.[n], after?.[n])).sort()
}

/** One line, in words, for a history row (#1279). */
export function describeThemeHistoryEntry(e: BrandThemeHistoryEntry): string {
  switch (e.action) {
    case 'create': return 'Created'
    case 'delete': return 'Deleted'
    case 'promote': return 'Promoted to company-level'
    case 'demote': return 'Demoted from company-level'
    case 'update': {
      const renamed = e.name_before && e.name_before !== e.theme_name ? `Renamed from "${e.name_before}"` : ''
      const brands = changedBrands(e.palette_before, e.palette_after)
      const colours = brands.length ? `colours changed: ${brands.join(', ')}` : ''
      if (renamed && colours) return `${renamed}; ${colours}`
      if (renamed) return renamed
      if (colours) return colours.charAt(0).toUpperCase() + colours.slice(1)
      return 'Saved with no changes'
    }
    default: return e.action
  }
}

export function formatHistoryTime(ms: number): string {
  return new Date(ms).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })
}
